import NpsByDeviceBarChart from './NpsByDeviceBarChart';
export default NpsByDeviceBarChart;



// WEBPACK FOOTER //
// ./src/components/NpsByDeviceBarChart/index.js